<template>
  <a
    v-tooltip="{
      content: tooltip,
      classes: 'badge-theme',
    }"
    :class="badgeClass"
    @click.prevent="copyToclip"
  >
    <font-awesome-icon :icon="icon" />
    <span class="pl-1"><slot></slot></span>

    <template v-if="copyToClipboard">
      <font-awesome-icon :icon="['fal', 'paste']" />
    </template>
  </a>
</template>

<script type="text/babel">
export default {
  props: {
    tooltip: {
      default: null,
    },

    copyToClipboard: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      required: false,
      default: "badge-large",
    },
  },

  data() {
    return {
      color: "badge-light",
      icon: ["fal", "ellipsis-v"],
    };
  },

  computed: {
    badgeClass() {
      return `badge badge-readable ${this.color} ${this.size} ${
        this.copyToClipboard ? "cursor" : ""
      }`;
    },
  },

  methods: {
    copyToclip() {
      if (this.copyToClipboard) {
        navigator.clipboard.writeText(this.tooltip);
        window.toastr.info("Tooltip copied to clipboard!", "Success");
      }
    },
  },
};
</script>
